import React from 'react';
import PropTypes from 'prop-types';
import { Navigation, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';
import 'swiper/swiper-bundle.css';

Partner3.propTypes = {
    data: PropTypes.array
};

function Partner3(props) {
    const { data } = props;
    return (
        <section className="tf-section supported p-4">
            <div className="overlay" style={{ background: 'rgb(14 3 39 / 50%)' }} />

            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="tf-title" data-aos="fade-up" data-aos-duration="800">
                            <h2 className="title">
                                Nuestros Socios
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container w_1710 brand_wrapper">
                <div className="row">
                    <div className="col-md-12">
                        <div className="brand">
                            <Swiper
                                modules={[Navigation, Autoplay]}
                                className='slider-12'
                                spaceBetween={5}
                                slidesPerView={5}
                                loop={true}
                                autoplay={{ delay: 5000, disableOnInteraction: false }}
                            >
                                {
                                    data.map(item => (
                                        <SwiperSlide key={item.id}>
                                            <Link to="#" className="image ">
                                                <img src={item.src} alt={item.alt} />
                                            </Link>
                                        </SwiperSlide>
                                    ))
                                }
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Partner3;